import isMobile from 'helpers/isMobile';

import { ArrowAngleLeft } from 'components/Icon';
import Logo from 'components/Logo';

import { HeaderWithLogoProps } from './types';

import * as S from './styled';

const HeaderWithLogo = ({ onBackButtonClick }: HeaderWithLogoProps) => (
    <S.HeaderWithLogo>
        <button onClick={onBackButtonClick} data-testid="modal-header-back-button">
            <ArrowAngleLeft size={20} />
        </button>
        <Logo withLogo={!isMobile.any()} />
    </S.HeaderWithLogo>
);

export default HeaderWithLogo;
